<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>warning</md-icon>
          </div>
          <h4 class="title">Payment Errors</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">

            <!-- Email -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <md-input type="text" placeholder="Search by Email" v-model="email"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-button class="md-primary" :disabled="isDisabled" @click="getPaymentErrorList()">
                Search
              </md-button>
            </div>
          </div>

          <hr>


          <!-- TABLE -->
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">

              <!-- Email -->
              <md-table-cell md-label="Email" md-sort-by="email">
                <div>
                  <strong>{{ item.email }}</strong>
                </div>
              </md-table-cell>

              <md-table-cell md-label="Error" md-sort-by="error">
                <span >{{ item.error }}</span>
              </md-table-cell>

              <md-table-cell md-label="Created At" md-sort-by="created_at">
                <span >{{ item.created_at }}</span>
              </md-table-cell>



            </md-table-row>
          </md-table>

        </md-card-content>

        <!-- Pagination Footer -->
        <md-card-actions md-alignment="space-between">
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  components: { Pagination },

  computed: {
    queriedData() {
      return this.tableData.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
    expiredRecently() {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      return this.tableData.filter(item => new Date(item.expiryAt) >= thirtyDaysAgo).length;
    },
    expiredLong() {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      return this.tableData.filter(item => new Date(item.expiryAt) < thirtyDaysAgo).length;
    }
  },

  data() {
    return {
      isDisabled: false,
      currentSort: "expiryAt",
      currentSortOrder: "desc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      email: "",
    };
  },

  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        const aVal = a[sortBy] ?? "";
        const bVal = b[sortBy] ?? "";
        if (this.currentSortOrder === "desc") return String(aVal).localeCompare(String(bVal));
        return String(bVal).localeCompare(String(aVal));
      });
    },

    getPaymentErrorList() {
      this.isDisabled = true;
      const params = {};
      if (this.email) params.email = this.email;

      UsersDataService.getPaymentErrorList(params)
        .then((response) => {
          this.tableData = response.data.data;
          this.pagination.currentPage = 1;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || 'Failed to load data');
        })
        .finally(() => {
          this.isDisabled = false;
        });
    },

  },

  beforeMount() {
    this.getPaymentErrorList();
  }
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

/* Stat Boxes */
.stat-box {
  background: #f0f4ff;
  border-left: 4px solid #4299e1;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}
.stat-box.warning { background: #fffbeb; border-left-color: #ed8936; }
.stat-box.danger  { background: #fff5f5; border-left-color: #f56565; }

.stat-number { font-size: 1.8rem; font-weight: 700; color: #2d3748; line-height: 1; }
.stat-label  { font-size: 0.8rem; color: #a0aec0; text-transform: uppercase; letter-spacing: 0.05em; }

/* Expiry colors */
.expiry-danger  { color: #c53030; font-weight: 700; }
.expiry-warning { color: #c05621; font-weight: 600; }
.expiry-recent  { color: #276749; font-weight: 600; }

/* Mono text */
.mono-text {
  font-family: monospace;
  font-size: 0.8rem;
  color: #718096;
  word-break: break-all;
}
</style>